/* 🤖 this file was generated by svg-to-ts */
export const mgcIconSelectorVerticalCuteFi: {
  name: 'selector-vertical-cute-fi';
  data: string;
} = {
  name: 'selector-vertical-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.988 13.061c-.502.061-1.187.201-1.388.285-.18.075-.384.271-.493.474-.137.258-.117.649.05.98.58 1.145 1.746 2.205 2.596 2.359.477.086.875-.049 1.54-.522.607-.433 1.18-1.112 1.551-1.837.295-.575.111-1.199-.424-1.441a3.81 3.81 0 0 0-.552-.156 9.254 9.254 0 0 0-2.88-.142"/></svg>`
};
